<header class="dialog-head">
  <span class="dialog-head-icon" aria-hidden="true"><mat-icon>{{ icon }}</mat-icon></span>
  <div class="dialog-head-text">
    <h2 class="dialog-title">{{ data.title }}</h2>
    <p class="dialog-subtitle">{{ subtitle }}</p>
  </div>
</header>

<mat-dialog-content class="dialog-body">
  <nubo-field
    label="Project name"
    hint="Shown in the switcher and wherever this agent is listed."
    labelFor="project-name">
    <div class="name-control">
      <!-- The avatar this project will carry everywhere, built from what is
           typed. It is how the switcher and the menus will identify it, so it
           sits on the input's own row rather than being announced afterwards. -->
      <nubo-avatar [name]="trimmedName" size="lg"></nubo-avatar>

      <mat-form-field appearance="outline" class="nubo-form-dense name-input">
        <input
          id="project-name"
          matInput
          [ngModel]="name"
          (ngModelChange)="onNameChange($event)"
          [maxlength]="MAX_NAME"
          placeholder="e.g. Support Agent"
          autocomplete="off"
          (keyup.enter)="submit()"
          cdkFocusInitial />
      </mat-form-field>
    </div>
  </nubo-field>

  <p class="name-count" aria-hidden="true">{{ countLabel }}</p>
</mat-dialog-content>

<mat-dialog-actions class="dialog-foot" align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="!trimmedName" (click)="submit()">
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>
